import DOMPurify from 'dompurify';

/**
 * Reusable HTML sanitiser for dangerouslySetInnerHTML sinks (TO-38136).
 * Strips scripts/event-handlers/dangerous markup so external or user-supplied
 * HTML (e.g. VDAB responses, candidate content) can't inject XSS. Use everywhere
 * we must render HTML: dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }}.
 */
export const sanitizeHtml = (dirty: string | null | undefined): string =>
  DOMPurify.sanitize(dirty ?? '', { USE_PROFILES: { html: true } });
